// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "replace",
                Decco.stringToJson(v.replace)
              ],
              [
                "replaceWith",
                Decco.stringToJson(v.replaceWith)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var replace = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replace"), null));
  if (replace.TAG === /* Ok */0) {
    var replaceWith = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceWith"), null));
    if (replaceWith.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                replace: replace._0,
                replaceWith: replaceWith._0
              }
            };
    }
    var e = replaceWith._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".replaceWith" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = replace._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".replace" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(param) {
  return "{replace=" + (param.replace + (", replaceWith=" + (param.replaceWith + "}")));
}

var Replacement = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  if (typeof v === "number") {
    return ["NoTransformation"];
  }
  switch (v.TAG | 0) {
    case /* ReplaceText */0 :
        return [
                "ReplaceText",
                Decco.stringToJson(v._0),
                t_encode(v._1),
                Decco.stringToJson(v._2)
              ];
    case /* DeleteText */1 :
        return [
                "DeleteText",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.stringToJson(v._2)
              ];
    case /* InsertText */2 :
        return [
                "InsertText",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                Decco.stringToJson(v._2)
              ];
    
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DeleteText" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* DeleteText */1,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "InsertText" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              if (match$6.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* InsertText */2,
                          _0: match$4._0,
                          _1: match$5._0,
                          _2: match$6._0
                        }
                      };
              }
              var e$3 = match$6._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "NoTransformation" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoTransformation */0
                  };
          }
      case "ReplaceText" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = t_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              if (match$9.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ReplaceText */0,
                          _0: match$7._0,
                          _1: match$8._0,
                          _2: match$9._0
                        }
                      };
              }
              var e$6 = match$9._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                      }
                    };
            }
            var e$7 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(v) {
  if (typeof v === "number") {
    return "NoTransformation";
  }
  switch (v.TAG | 0) {
    case /* ReplaceText */0 :
        return "ReplaceText(sharedPrefix=" + (v._0 + (", replacement=" + (stringify(v._1) + (", sharedSuffix=" + (v._2 + ")")))));
    case /* DeleteText */1 :
        return "DeleteText(sharedPrefix=" + (v._0 + (", deletedText=" + (v._1 + (", sharedSuffix=" + (v._2 + ")")))));
    case /* InsertText */2 :
        return "InsertText(sharedPrefix=" + (v._0 + (", insertedText=" + (v._1 + (", sharedSuffix=" + (v._2 + ")")))));
    
  }
}

var StringTransformation = {
  Replacement: Replacement,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function findCommonLeadingChars(chars1, chars2) {
  if (!chars1) {
    return /* [] */0;
  }
  if (!chars2) {
    return /* [] */0;
  }
  var ch1 = chars1.hd;
  if (ch1 === chars2.hd) {
    return {
            hd: ch1,
            tl: findCommonLeadingChars(chars1.tl, chars2.tl)
          };
  } else {
    return /* [] */0;
  }
}

function findCommonPrefix(str1, str2) {
  var charsForStr1 = StringUtils$SmartcutsMacros.split("", str1);
  var charsForStr2 = StringUtils$SmartcutsMacros.split("", str2);
  return StringUtils$SmartcutsMacros.join("", findCommonLeadingChars(charsForStr1, charsForStr2));
}

function findCommonSuffix(str1, str2) {
  var charsForReverseStr1 = Belt_List.reverse(StringUtils$SmartcutsMacros.split("", str1));
  var charsForReverseStr2 = Belt_List.reverse(StringUtils$SmartcutsMacros.split("", str2));
  return StringUtils$SmartcutsMacros.join("", Belt_List.reverse(findCommonLeadingChars(charsForReverseStr1, charsForReverseStr2)));
}

function calcStringTransformation(orderOpt, str1Selection, str1, str2) {
  var order = orderOpt !== undefined ? orderOpt : /* Forward */0;
  if (str1 === str2) {
    return /* NoTransformation */0;
  }
  if (Caml_obj.caml_equal(str1Selection, [
          0,
          str1.length
        ]) && str1 !== str2) {
    return {
            TAG: /* ReplaceText */0,
            _0: "",
            _1: {
              replace: str1,
              replaceWith: str2
            },
            _2: ""
          };
  }
  var match;
  if (order) {
    var sharedSuffix = findCommonSuffix(str1, str2);
    var str1WithoutSharedSuffix = StringUtils$SmartcutsMacros.removeTrailingSuffix(str1, sharedSuffix);
    var str2WithoutSharedSuffix = StringUtils$SmartcutsMacros.removeTrailingSuffix(str2, sharedSuffix);
    var sharedPrefix = findCommonPrefix(str1WithoutSharedSuffix, str2WithoutSharedSuffix);
    var replace = StringUtils$SmartcutsMacros.removeLeadingPrefix(str1WithoutSharedSuffix, sharedPrefix);
    var replaceWith = StringUtils$SmartcutsMacros.removeLeadingPrefix(str2WithoutSharedSuffix, sharedPrefix);
    match = [
      sharedPrefix,
      sharedSuffix,
      replace,
      replaceWith
    ];
  } else {
    var sharedPrefix$1 = findCommonPrefix(str1, str2);
    var str1WithoutSharedPrefix = StringUtils$SmartcutsMacros.removeLeadingPrefix(str1, sharedPrefix$1);
    var str2WithoutSharedPrefix = StringUtils$SmartcutsMacros.removeLeadingPrefix(str2, sharedPrefix$1);
    var sharedSuffix$1 = findCommonSuffix(str1WithoutSharedPrefix, str2WithoutSharedPrefix);
    var replace$1 = StringUtils$SmartcutsMacros.removeTrailingSuffix(str1WithoutSharedPrefix, sharedSuffix$1);
    var replaceWith$1 = StringUtils$SmartcutsMacros.removeTrailingSuffix(str2WithoutSharedPrefix, sharedSuffix$1);
    match = [
      sharedPrefix$1,
      sharedSuffix$1,
      replace$1,
      replaceWith$1
    ];
  }
  var replaceWith$2 = match[3];
  var replace$2 = match[2];
  var sharedSuffix$2 = match[1];
  var sharedPrefix$2 = match[0];
  if (replace$2 === "") {
    return {
            TAG: /* InsertText */2,
            _0: sharedPrefix$2,
            _1: replaceWith$2,
            _2: sharedSuffix$2
          };
  } else if (replaceWith$2 === "") {
    return {
            TAG: /* DeleteText */1,
            _0: sharedPrefix$2,
            _1: replace$2,
            _2: sharedSuffix$2
          };
  } else {
    return {
            TAG: /* ReplaceText */0,
            _0: sharedPrefix$2,
            _1: {
              replace: replace$2,
              replaceWith: replaceWith$2
            },
            _2: sharedSuffix$2
          };
  }
}

exports.StringTransformation = StringTransformation;
exports.findCommonLeadingChars = findCommonLeadingChars;
exports.findCommonPrefix = findCommonPrefix;
exports.findCommonSuffix = findCommonSuffix;
exports.calcStringTransformation = calcStringTransformation;
/* StringUtils-SmartcutsMacros Not a pure module */
